/**
 * Inbox unificado cross-canal — vista principal del operador (v2.1).
 *
 * Layout 2-col dentro del Shell:
 *   - Col 1 (360px): ConversationsList — header sticky + filters + lista densa.
 *   - Col 2 (flex-1): EmptyState — al clickear una card va a /inbox/$id.
 *
 * El sidebar global vive en Shell, no acá.
 */
import { Inbox as InboxIcon } from "lucide-react";
import { ConversationsList } from "@/components/inbox/conversations-list";
import { EmptyState } from "@/components/shared/empty-state";
import { Kbd } from "@/components/shared/kbd";

export function InboxPage() {
  return (
    <div className="flex h-full min-h-0 bg-background">
      <ConversationsList />

      {/* Col 2 — detail vacío */}
      <section className="flex-1 min-w-0 flex items-center justify-center bg-background">
        <EmptyState
          icon={<InboxIcon size={32} strokeWidth={1.5} />}
          title="Seleccioná una conversación"
          description="Usá J / K o las flechas para navegar la lista"
          action={
            <div className="flex items-center gap-2 mt-2 text-text-muted">
              <Kbd keys="J" />
              <Kbd keys="K" />
              <span className="font-sans text-xs">para moverte</span>
            </div>
          }
        />
      </section>
    </div>
  );
}
